import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const BulkCreate = loadable(() => import('./BulkCreate'), {});
export const Product = loadable(() => import('./Product'), {});
export const Store = loadable(() => import('./Store'), {});
export const Toggle = loadable(() => import('./Toggle'), {});
export const ChangeCycle = loadable(() => import('./ChangeCycle'), {});
